var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "atlas-introduction", attrs: { id: "atlas-introduction" } },
    [
      _vm._l(_vm.titles, function(title) {
        return _c(
          "p",
          { key: title, staticClass: "atlas-introduction__title" },
          [_vm._v("\n          " + _vm._s(title) + "\n       ")]
        )
      }),
      _vm._v(" "),
      _c("p", { staticClass: "atlas-introduction__en-title" }, [
        _vm._v(_vm._s(_vm.en_title))
      ]),
      _vm._v(" "),
      _vm._l(_vm.update_messages, function(update_message) {
        return _c(
          "p",
          {
            key: update_message,
            staticClass: "atlas-introduction__update-msg"
          },
          [_vm._v("\n          " + _vm._s(update_message) + "\n       ")]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }